// Animated Background Component for PlexiSystem 4.0
import React from 'react';

export const AnimatedBackground: React.FC = () => {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      {/* Enhanced gradient orbs with crystal effect */}
      <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-violet-500 via-purple-500 to-pink-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob" />
      <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-br from-cyan-500 via-blue-500 to-indigo-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000" />
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-gradient-to-br from-emerald-500 via-teal-500 to-cyan-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000" />
      
      {/* Additional crystal light effects */}
      <div className="absolute top-1/4 right-1/4 w-60 h-60 bg-gradient-to-br from-orange-400 to-pink-400 rounded-full mix-blend-screen filter blur-2xl opacity-10 animate-pulse" />
      <div className="absolute bottom-1/4 left-1/4 w-60 h-60 bg-gradient-to-br from-purple-400 to-indigo-400 rounded-full mix-blend-screen filter blur-2xl opacity-10 animate-pulse animation-delay-2000" />
      
      {/* Grid pattern - like looking through plexi */}
      <svg className="absolute inset-0 w-full h-full opacity-[0.02]">
        <defs>
          <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
            <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1"/>
          </pattern>
          <linearGradient id="grid-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="white" stopOpacity="0.1" />
            <stop offset="100%" stopColor="white" stopOpacity="0.02" />
          </linearGradient>
        </defs>
        <rect width="100%" height="100%" fill="url(#grid)" />
      </svg>
      
      {/* Crystal refraction lines */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-1/4 w-px h-full bg-gradient-to-b from-transparent via-white to-transparent animate-shimmer" />
        <div className="absolute top-0 left-2/4 w-px h-full bg-gradient-to-b from-transparent via-white to-transparent animate-shimmer animation-delay-1000" />
        <div className="absolute top-0 left-3/4 w-px h-full bg-gradient-to-b from-transparent via-white to-transparent animate-shimmer animation-delay-2000" />
      </div>
    </div>
  );
};

// Export animations for global styles
export const backgroundAnimations = `
  @keyframes blob {
    0% { transform: translate(0px, 0px) scale(1) rotate(0deg); }
    33% { transform: translate(30px, -50px) scale(1.1) rotate(120deg); }
    66% { transform: translate(-20px, 20px) scale(0.9) rotate(240deg); }
    100% { transform: translate(0px, 0px) scale(1) rotate(360deg); }
  }
  
  @keyframes shimmer {
    0% { transform: translateY(-100%); opacity: 0; }
    50% { opacity: 0.1; }
    100% { transform: translateY(100%); opacity: 0; }
  }
  
  @keyframes wiggle {
    0%, 100% { transform: rotate(0deg); }
    25% { transform: rotate(-10deg); }
    75% { transform: rotate(10deg); }
  }
  
  @keyframes float {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-20px); }
  }
  
  @keyframes glow {
    0%, 100% { opacity: 0.5; }
    50% { opacity: 1; }
  }
  
  .animate-blob {
    animation: blob 15s infinite;
  }
  
  .animate-shimmer {
    animation: shimmer 8s infinite;
  }
  
  .animation-delay-1000 {
    animation-delay: 1s;
  }
  
  .animation-delay-2000 {
    animation-delay: 2s;
  }
  
  .animation-delay-4000 {
    animation-delay: 4s;
  }
  
  .group:hover .animate-wiggle {
    animation: wiggle 0.5s ease-in-out;
  }
  
  .animate-float {
    animation: float 3s ease-in-out infinite;
  }
  
  .animate-glow {
    animation: glow 2s ease-in-out infinite;
  }
`;
